export default "__VITE_ASSET__DSoNjDWf__"